  let estatus_baja = Object.freeze({
    PENDIENTE:1,
    PROCESO:2,
    CALCULADO:3,
    AFECTADO:4,
    PAGADO:5,
    TIMBRADO:6,
    CANCELADO:7,
    ERROR:0,
    list: [
        { label: 'Pendiente', value: 1 },
        { label: 'Proceso', value: 2 },
        { label: 'Calculado', value: 3 },
        { label: 'Afectado', value: 4 },
        { label: 'Pagado', value: 5 },
        { label: 'Timbrado', value: 6 },
        { label: 'Cancelado', value: 0 },
    ]
  });
module.exports = { estatus_baja }